import AlternativeSpanish from './alternativeSpanish'

export default AlternativeSpanish